import { Box, Typography, TextField, Grid } from "@mui/material";
import { shades } from "../../theme";

const checkoutInputSx = {
  minHeight: "36px",
  "& .MuiOutlinedInput-root": {
    minHeight: "36px",
    padding: "3px 4px",
    "& input": {
      padding: "13px 100px",
      fontSize: "1.08rem",
      textAlign: "left",
    },
    "&::placeholder": {
      fontSize: "0.95rem",
      opacity: 1,
      color: "#cccccc",
    },
    "& fieldset": {
      borderColor: shades.neutral[300],
    },
    "&:hover fieldset": {
      borderColor: shades.neutral[400],
    },
  },
  "& .MuiOutlinedInput-input::placeholder": {
    fontSize: "0.95rem",
    opacity: 1,
    color: "#cccccc",
  },
};

const Payment = ({ values, errors, touched, handleBlur, handleChange }) => {
  return (
    <Box m="20px 0">
      <Typography sx={{ mb: "15px" }} fontSize="18px">
        Contact Information
      </Typography>
      <Box display="flex" justifyContent="center" width="100%">
        <Grid container spacing={2} sx={{ maxWidth: 900, width: "100%" }}>
          <Grid item xs={12} md={6}>
            <TextField
              fullWidth
              type="email"
              label="Email"
              onBlur={handleBlur}
              onChange={handleChange}
              value={values.email}
              name="email"
              error={!!touched.email && !!errors.email}
              helperText={touched.email && errors.email}
              sx={checkoutInputSx}
            />
          </Grid>
          <Grid item xs={12} md={6}>
            <TextField
              fullWidth
              type="text"
              label="Phone Number"
              onBlur={handleBlur}
              onChange={handleChange}
              value={values.phoneNumber}
              name="phoneNumber"
              error={!!touched.phoneNumber && !!errors.phoneNumber}
              helperText={touched.phoneNumber && errors.phoneNumber}
              sx={checkoutInputSx}
            />
          </Grid>
        </Grid>
      </Box>
    </Box>
  );
};

export default Payment;
